import { executeProcedureCalculator } from '../../../../../services/exam';
import { CALCULATOR_TYPES, PROCEDURE_CODES } from './calculatorRegistry';
import { message } from "antd";

export const handleVFGCalculation = async (value, admissionPatientId, form, procedures) => {
  if (!admissionPatientId) return ;

  let vfgResult = null;

  if (value) {
    try {
      vfgResult = await executeProcedureCalculator({
        body: {
          procedureType: CALCULATOR_TYPES.VFG,
          id: admissionPatientId,
          creatinina: value
        }
      });
    } catch (error) {
      console.error('Error calculando VFG:', error);
      message.error({
        content: 'Error calculando VFG',
        style: {
          marginTop: '40vh',
        },
      });
      vfgResult = null;
    }
  }

  const vfgProcedure = procedures.find(
    proc => proc.code === PROCEDURE_CODES.VFG
  );

  if (vfgProcedure) {
    const currentValues = form.getFieldsValue();
    form.setFieldsValue({
      procedures: {
        ...currentValues.procedures,
        [vfgProcedure.id.toString()]: vfgResult
      }
    });

    if (vfgResult) {
      return [{
        result: vfgResult,
        calculatedFieldId: vfgProcedure.id,
        calculatedFieldCode: vfgProcedure.code
      }];
    }
  }

  return [vfgResult];
};
